import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { registerCustomer } from '@/lib/shopifyCustomer';

const RegisterPage = () => {
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    senha: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.senha.length < 8) {
      toast.error('A senha deve ter no mínimo 8 caracteres');
      return;
    }

    setLoading(true);

    try {
      const result = await registerCustomer(formData);

      if (result.customerUserErrors && result.customerUserErrors.length > 0) {
        toast.error(result.customerUserErrors[0].message);
        return;
      }

      toast.success('Conta criada com sucesso! Agora faça login.');

      setFormData({
        nome: '',
        email: '',
        senha: ''
      });
    } catch {
      toast.error('Erro ao criar conta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-24 pb-16 px-6 flex items-center">
      <div className="max-w-[1400px] mx-auto w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-md mx-auto bg-white rounded-2xl shadow-sm p-10"
        >
          <h1 className="font-heading text-4xl font-bold text-center mb-8">
            Criar Conta
          </h1>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label className="block mb-2">Nome</label>
              <input
                type="text"
                name="nome"
                value={formData.nome}
                onChange={handleChange}
                className="w-full h-12 rounded-xl border px-4 focus:ring-2 focus:ring-accent/30"
                required
              />
            </div>

            <div>
              <label className="block mb-2">E-mail</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="w-full h-12 rounded-xl border px-4 focus:ring-2 focus:ring-accent/30"
                required
              />
            </div>

            <div>
              <label className="block mb-2">Senha</label>
              <input
                type="password"
                name="senha"
                value={formData.senha}
                onChange={handleChange}
                className="w-full h-12 rounded-xl border px-4 focus:ring-2 focus:ring-accent/30"
                minLength={8}
                required
              />
              <p className="mt-1 text-xs text-gray-400">Mínimo de 8 caracteres</p>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="w-full bg-accent text-white rounded-full h-12"
            >
              {loading ? 'Criando conta...' : 'Criar Conta'}
            </Button>

            <p className="text-center text-sm text-gray-500">
              Já tem conta?{' '}
              <a href="/login" className="text-accent font-semibold">
                Entrar
              </a>
            </p>
          </form>
        </motion.div>
      </div>
    </div>
  );
};

export default RegisterPage;